module.exports = __webpack_public_path__ + "css/Ascot.1e7cc841.css";